import { QueryConfig } from "store/utils/query-config";

export const dynamicFormsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
